import React, { FC, useState, useRef, useEffect } from 'react';
import { map } from 'lodash';
import { Icon, IconSize, ButtonAppearance, ButtonSize } from '@bechtel/gds';
import {
  CarouselStyled,
  CarouselItemStyled,
  CarouselTrackStyled,
  CarouselButtonLeftStyled,
  CarouselButtonRightStyled,
  CarouselRightButtonAreaStyled,
  CarouselLeftButtonAreaStyled,
  CarouselDisabledAreaStyled,
} from './styled';

export const Carousel: FC = ({ children }) => {
  const carouselItems = React.Children.toArray(children);
  const [swipeStart, setSwipeStart] = useState(0);
  const [translateX, setTranslateX] = useState(0);
  const carouselRef = useRef<HTMLDivElement>(null);
  const [carouselItemWidth, setCarouselItemWidth] = useState<number>();
  const [carouselItemMargin, setCarouselItemMargin] = useState<number>(0);
  const [position, setPosition] = useState(0); //Initial position is 1
  const carouselItemsLength = carouselItems.length + 2;
  const moveLeft = () => {
    if (!carouselItemWidth) return;
    if (position === 0) {
      setPosition(carouselItems.length - 1);
      setTranslateX(translateX - (carouselItems.length - 1) * (carouselItemWidth + carouselItemMargin));
    } else {
      setPosition(position - 1);
      setTranslateX(translateX + (carouselItemWidth + carouselItemMargin));
    }
  };

  const moveRight = () => {
    if (!carouselItemWidth) return;
    if (position === carouselItems.length - 1) {
      setPosition(0);
      setTranslateX(translateX + (carouselItems.length - 1) * (carouselItemWidth + carouselItemMargin));
    } else {
      setPosition(position + 1);
      setTranslateX(translateX - (carouselItemWidth + carouselItemMargin));
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const carouselWidth = carouselRef?.current?.clientWidth || 0;
      setCarouselItemWidth((carouselWidth * 76) / 100);
      setCarouselItemMargin((carouselWidth * 2) / 100);
      setTranslateX(-(carouselWidth * 66) / 100);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isTouchDevice = () => {
    const supportsTouch = 'ontouchstart' in window;
    return supportsTouch;
  };

  const touchStart = (event) => {
    if (!isTouchDevice()) return;
    setSwipeStart(event.nativeEvent.touches[0].clientX);
  };

  const touchEnd = (event) => {
    if (!isTouchDevice()) return;

    //If swipe left
    if (event.changedTouches.item(0).clientX > swipeStart) {
      moveLeft();
    }
    //if swipe right
    else if (event.changedTouches.item(0).clientX < swipeStart) {
      //Else if required here
      moveRight();
    }
    //else - if is just a touch, i.e if event.changedTouches.item(0).clientX  === swipeStart
  };
  return (
    <CarouselStyled onTouchStart={touchStart} onTouchEnd={touchEnd} ref={carouselRef}>
      <CarouselLeftButtonAreaStyled onClick={() => moveLeft()}>
        <CarouselDisabledAreaStyled>
          {!isTouchDevice() && (
            <CarouselButtonLeftStyled appearance={ButtonAppearance.SECONDARY} size={ButtonSize.LARGE}>
              <Icon icon="chevron-left" size={IconSize.LARGE} fillColor="blue.800" />
            </CarouselButtonLeftStyled>
          )}
        </CarouselDisabledAreaStyled>
      </CarouselLeftButtonAreaStyled>
      <CarouselRightButtonAreaStyled onClick={() => moveRight()}>
        <CarouselDisabledAreaStyled>
          {!isTouchDevice() && (
            <CarouselButtonRightStyled appearance={ButtonAppearance.SECONDARY} size={ButtonSize.LARGE}>
              <Icon icon="chevron-right" size={IconSize.LARGE} fillColor="blue.800" />
            </CarouselButtonRightStyled>
          )}
        </CarouselDisabledAreaStyled>
      </CarouselRightButtonAreaStyled>
      <CarouselTrackStyled
        translateX={translateX}
        style={
          carouselItemWidth && !isNaN(carouselItemWidth)
            ? {
                width: carouselItemWidth * carouselItemsLength + carouselItemMargin * (carouselItemsLength - 1),
              }
            : {}
        }
      >
        <CarouselItemStyled style={{ width: carouselItemWidth, marginRight: carouselItemMargin }}>
          {carouselItems[carouselItems.length - 1]}
        </CarouselItemStyled>
        {map(carouselItems, (item, index) => {
          return (
            <CarouselItemStyled
              key={index}
              style={{ width: carouselItemWidth, marginRight: carouselItemMargin }}
              selected={position === index}
            >
              {item}
            </CarouselItemStyled>
          );
        })}
        <CarouselItemStyled style={{ width: carouselItemWidth }}>{carouselItems[0]}</CarouselItemStyled>
      </CarouselTrackStyled>
    </CarouselStyled>
  );
};
